(function () {
"use strict";
(function($) {
    $(window).on('load', function() {
        let popularPosts = [];
        const elsTabTriggers = [
            ...document.getElementsByClassName('js-tab-links')
        ];
        const elsTabs = [
            ...document.getElementsByClassName('js-tabs')
        ];
        const elTabBtnsWrapper = document.querySelector('.tab-links-wrapper');
        if (!elTabBtnsWrapper) return;
        let isMountedMostPopular = false;
        elTabBtnsWrapper.addEventListener('click', ()=>{
            mountMostPopular().then(()=>isMountedMostPopular === true);
        }, {
            once: true
        });
        const elToAnimate = document.createElement('div');
        elToAnimate.classList.add('active-anim', 'border-bottom', 'border-secondary', 'position-absolute');
        elToAnimate.style.width = elsTabTriggers[0].offsetWidth + 'px';
        elTabBtnsWrapper.insertAdjacentElement('beforeEnd', elToAnimate);
        // Add position-relative class to parent element
        elTabBtnsWrapper.classList.add('position-relative');
        elToAnimate.style.bottom = '0px';
        elsTabTriggers.forEach((el)=>{
            el.addEventListener('click', (e)=>{
                // Remove active class
                elsTabTriggers.forEach((el)=>{
                    el.classList.remove('active');
                });
                // Reset / hide all panels
                elsTabs.forEach((el)=>{
                    el.classList.add('d-none');
                });
                if (!e.target.classList.contains('active')) {
                    e.target.classList.add('active');
                    // Show target panel
                    document.getElementById(e.target.dataset.targetId).classList.remove('d-none');
                }
                // Animate tab buttons
                if (anime !== 'undefined') {
                    const widthOfEl = e.target.offsetWidth;
                    const distanceForTranslateX = e.target.offsetLeft;
                    anime({
                        targets: elToAnimate,
                        translateX: distanceForTranslateX,
                        width: widthOfEl,
                        easing: 'easeOutQuad',
                        duration: 300,
                        delay: 100
                    });
                    elToAnimate.style.width = widthOfEl;
                }
            });
        });
        function mountMostPopular() {
            triggerIntegratePremiumLock();
            return new Promise((resolve, reject)=>{
                // Configuration for rendering initial parsley posts.
                let $placeholderContainer = $('#init-posts');
                // Configuration for rendering parsley posts from button click
                let queryObjName = window.adw_most_popular_term;
                if (!window.adw_most_popular_term) return;
                queryObjName = queryObjName.includes('&amp;') ? queryObjName.replace('&amp;', '&') : queryObjName;
                const queryParam = encodeURIComponent(queryObjName);
                if (popularPosts.length > 0) $placeholderContainer.replaceWith(popularPosts);
                else // Executing render of initial parsley posts.
                adw.parsely.getPopularCategoryPosts(queryParam, 1).then((response)=>{
                    if (response) {
                        if (response.data.length === 0) {
                            $placeholderContainer.replaceWith('<p>No Posts Found</p>');
                            return;
                        }
                        const sanitizedData = response.data.map(function(dataItem) {
                            return new Promise((resolve, reject)=>{
                                const { url: url, image_url: image_url, title: title, author: author, pub_date: pub_date, section: section } = dataItem;
                                let post_id = '';
                                let postUrl = '';
                                if (url.includes('http://www.adweek.com')) postUrl = url.replace('http://www.adweek.com', window.location.origin);
                                if (url.includes('https://www.adweek.com')) postUrl = url.replace('https://www.adweek.com', window.location.origin);
                                jQuery.ajax({
                                    type: "post",
                                    dataType: "json",
                                    url: adw.ajaxurl,
                                    async: true,
                                    data: {
                                        action: "aw_url_to_postid",
                                        post_url: postUrl
                                    },
                                    complete: function(response) {
                                        if (response && response.status == 200) {
                                            const responseData = response.responseJSON;
                                            if (response !== 0) post_id = responseData;
                                            resolve({
                                                post_id: post_id,
                                                url: url,
                                                title: title,
                                                author: author,
                                                label: section,
                                                pubDate: pub_date,
                                                imageUrl: !image_url.includes("apple-touch-icon.png") ? adw.utils.replaceUrls(image_url) : ''
                                            });
                                        }
                                    }
                                });
                            });
                        });
                        let postIdList;
                        Promise.all([
                            ...sanitizedData
                        ]).then((data)=>{
                            postIdList = data.map((post)=>post?.post_id);
                            let postIdListFiltered = postIdList.filter((post_id)=>post_id !== 0);
                            adw.posts.getPostsMarkupByIDs(postIdListFiltered, 'index_item').then((markupList)=>{
                                let markup = markupList !== undefined ? markupList.reduce((markup, item)=>markup + item) : '';
                                popularPosts.push(markup);
                                $placeholderContainer.replaceWith(markup);
                                $('.section__kickerlabel').addClass('d-none');
                                triggerIntegratePremiumLock();
                                resolve(true);
                            }).then(function() {
                                $('[data-bs-toggle="tooltip"]').tooltip();
                            });
                        });
                    } else $placeholderContainer.replaceWith('<p>No Posts Found</p>');
                });
            });
        }
        $('.result-actions').removeClass('d-none');
        $('.recent-posts-wrapper').on('click', function() {
            $('#recent-posts-wrapper').removeClass('d-none');
        });
    });
})(jQuery);

})();
//# sourceMappingURL=archive-most-popular.js.map
